import axios from "axios";
import { getToken } from "./auth";

// Axios instance
const service = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API_V1 + "/api/v1", // base API URL from environment variables
  timeout: 90000, //default timeout of 10 seconds
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

// Request interceptor to add token if available
service.interceptors.request.use(
  (config) => {
    const token = getToken(); //token storage method here
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`; // Add token to header if exists
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for handling responses
service.interceptors.response.use(
  (response) => {
    return response.data; // Directly return response data
  },
  (error) => {
    console.error(
      "Request failed:",
      error.response?.data?.message || error.message
    );
    return Promise.reject(error);
  }
);

export default service;
